module.exports = __webpack_public_path__ + "media/images/athletes/4-25561dbb49dad2fa6c7183179348c8ed.png";